import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { toastCommonestyle } from "../../utils/Toast";
import { toast } from "react-toastify";
import { clearStore } from "../../utils/indexDB/indexDB";
const LoginToken = () => {
  const location = useLocation();

  const navigator = useNavigate();
  const Notfy = (er: string) => {
    return toast.warning(er, toastCommonestyle as any);
  };
  interface DecodedToken {
    exp: number;
  }

  const validateToken = async (token: string) => {
    try {
      await clearStore();
      const decoded = jwtDecode<DecodedToken>(token);
      localStorage.setItem("access_token", JSON.stringify(token));
      // Check if the token is expired

      setTimeout(() => {
        if (decoded.exp < Date.now() / 1000) {
          let Api_URL: any = "";
          const env = process.env.REACT_APP_STAGE_ENV;
          switch (env) {
            case "dev":
              Api_URL = "https://dev.login.ticca.com/?domain=dev.www.ticca.ltd";
              break;
            case "stage":
              Api_URL =
                "https://stage.login.ticca.com/?domain=stage.www.ticca.ltd";
              break;
            case "prod":
              Api_URL = "https://login.ticca.com/?domain=www.ticca.ltd";
              break;
            default:
              Api_URL = "https://dev.login.ticca.com/?domain=dev.www.ticca.ltd";
              break;
          }
          window.location.href = Api_URL;
        }

        navigator("/");
      }, 2000);

      navigator("/");
    } catch (error) {
      let Api_URL: any = "";
      const env = process.env.REACT_APP_STAGE_ENV;
      switch (env) {
        case "dev":
          Api_URL = "https://dev.login.ticca.com/?domain=dev.www.ticca.ltd";
          break;
        case "stage":
          Api_URL = "https://stage.login.ticca.com/?domain=stage.www.ticca.ltd";
          break;
        case "prod":
          Api_URL = "https://login.ticca.com/?domain=www.ticca.ltd";
          break;
        default:
          Api_URL = "https://dev.login.ticca.com/?domain=dev.www.ticca.ltd";
          break;
      }
      window.location.href = Api_URL;
    }
  };
  useEffect(() => {
    const jwtToken = new URLSearchParams(location.search).get("jwt");

    const queryParams = new URLSearchParams(location.search);

    const error = queryParams.get("error");
    if (jwtToken) {
      validateToken(jwtToken);
    } else if (error == "unauthorized") {
      Notfy("Your current permission do not allow to access this domain");
      navigator("/");
    } else {
      let Api_URL: any = "";
      const env = process.env.REACT_APP_STAGE_ENV;
      switch (env) {
        case "dev":
          Api_URL = "https://dev.login.ticca.com/?domain=dev.www.ticca.ltd";
          break;
        case "stage":
          Api_URL = "https://stage.login.ticca.com/?domain=stage.www.ticca.ltd";
          break;
        case "prod":
          Api_URL = "https://login.ticca.com/?domain=www.ticca.ltd";
          break;
        default:
          Api_URL = "https://dev.login.ticca.com/?domain=dev.www.ticca.ltd";
          break;
      }
      window.location.href = Api_URL;
    }
  }, [location.search]);

  return <></>;
};

export default LoginToken;
